module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 16c1.106 0 2-.894 2-2V2c0-1.1-.9-2-2-2H2a2 2 0 1 0 0 4h2v18c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2 0-1.312-.894-2-2-2H8v-4h22zM12 29a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm18 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/cart-2.js
// module id = 1049
// module chunks = 14